import React from 'react';
import { Box, Button, ButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import "../styles/languageToggle.css";

function LanguageToggle() {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith('es') ? 'es' : 'en';

  const setLanguage = (language) => {
    if (language !== current) {
      i18n.changeLanguage(language);
    }
  };

  return (
    <Box className="language-toggle">
      <ButtonGroup size="small" variant="outlined" aria-label="Language selector">
        <Button
          onClick={() => setLanguage('es')}
          variant={current === 'es' ? 'contained' : 'outlined'}
        >
          ES
        </Button>
        <Button
          onClick={() => setLanguage('en')}
          variant={current === 'en' ? 'contained' : 'outlined'}
        >
          EN
        </Button>
      </ButtonGroup>
    </Box>
  );
}

export default LanguageToggle;
